
import { useState } from "react";
import { URL_BACKEND } from "../../api/url";
import { elToast } from "../../functions/alertas";
import { useLoginStore } from "../../stores/useLoginStore";

export const useSubirDatos = () => {

    const { token } = useLoginStore( store => store.objLogueado )

    // useStates
    const [archivo, setArchivo] = useState(null);
    const [cargando, setCargando] = useState(false)

    const procesarArchivos = (e) => {

        if (e.target.value !== "") {

            var archivo_input = e.target.files[0]

            var nombreDividido = archivo_input.name.split(".")
            var tipo = nombreDividido[ nombreDividido.length-1 ]


            if (tipo.toLowerCase() === "xls" || tipo.toLowerCase() === "xlsx") {

                let reader = new FileReader()
                reader.readAsDataURL(archivo_input)
                reader.onload = (f) => {
                    setArchivo(f.target.result)
                }
            } else {
                alert("Sólo se permiten archivos de Excel")
            }
        }
    }

    const onFinish = (e) => {

        e.preventDefault()
        // setCargando( true )

        if ( archivo == null) {
            elToast("Debes agregar un archivo válido", "error")
            setCargando( false )
            return
        }

        let formData = new FormData();
        formData.append('funcion', 'subirExcelAspirantes');
        formData.append('archivo', archivo);
        formData.append('token', token);

        fetch( URL_BACKEND, {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(function (d) {

            console.log(d);
            setCargando(false)

            if (d.codigo === 1) {
                
                elToast("Datos cargados con éxito")

            } else {
                elToast(d.mensaje, 'error')
            }

        })
        // .catch( function ( error ) {
        //     console.log( error );
        //     elToast('Error al subir archivo', 'error')
        //     setCargando( false )
        // })
    }

    return {
        onFinish,
        procesarArchivos,
        cargando
    }
}
